import React, {useState} from 'react';
import CurrentState from './CurrentStateEnum';
import Auth from "./Auth";
import SecondaryAuthorizationForm from "./SecondaryAuthorizationForm";
import OTPForm from "./OTPForm";
import {Alert, Spinner} from "react-bootstrap";
import SuccessRegistration from "./SuccessRegistration";
import {Account, SecondaryAuthorizationData} from "./api";

const LoginForm : React.FC = () => {

    const [currentState, setCurrentState] = useState(CurrentState.FirstLoginForm);

    const [accounts, setAccounts] = useState([] as Account[]);

    const [error, setError] = useState("");

    const [rendering, setRendering] = useState(false);

    const [customerName, setCustomerName] = useState("");

    const [secondaryAuthorizationData, setSecondaryAuthorizationData] = useState<SecondaryAuthorizationData | null>(null);

    const renderSpinner = () => {
        if(rendering){
            return (
                <Spinner
                    as="span"
                    size="sm"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                />
            )
        }
    };

    const renderError = () => {
        if (error !== ""){
            return (
                <Alert variant= "danger">
                    {error}
                </Alert>
            )
        }
    };

    const renderSwitch = () =>{
        switch (currentState) {
            case CurrentState.FirstLoginForm:
                return (
                    <Auth
                        setSecondaryAuthorizationData={setSecondaryAuthorizationData}
                        setCustomerName={setCustomerName}
                        setCurrentState={setCurrentState}
                        setAccounts={setAccounts}
                        setError={setError}
                        setRendering={setRendering}
                        renderSpinner ={renderSpinner}
                        renderError={renderError}/>
                );
            case CurrentState.SecondaryAuthForm:
                return (<SecondaryAuthorizationForm
                            accounts={accounts}
                            setSecondaryAuthorizationData={setSecondaryAuthorizationData}
                            secondaryAuthorizationData={secondaryAuthorizationData}
                            setCurrentState={setCurrentState}
                            setError={setError}
                            setRendering={setRendering}
                            renderSpinner ={renderSpinner}
                            renderError={renderError}
                            customerName={customerName}/>);
            case CurrentState.OTPForm:
                return (<OTPForm
                            setSecondaryAuthorizationData={setSecondaryAuthorizationData}
                            secondaryAuthorizationData={secondaryAuthorizationData}
                            setCurrentState={setCurrentState}
                            setError={setError}
                            setRendering={setRendering}
                            renderSpinner ={renderSpinner}
                            renderError={renderError}/>);
            case CurrentState.Finished:
                return(
                    <SuccessRegistration
                        customerName={customerName}
                        secondaryAuthorizationData={secondaryAuthorizationData}/>
                )
        }
    };

    return renderSwitch();
    };

export default LoginForm;
